var _classCallCheck = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var GoogleSpreadsheetFormulaError = function GoogleSpreadsheetFormulaError(errorInfo) {
  "use strict";

  _classCallCheck(this, GoogleSpreadsheetFormulaError);

  this.type = errorInfo.type;
  this.message = errorInfo.message;
};

module.exports = {
  GoogleSpreadsheetFormulaError: GoogleSpreadsheetFormulaError
};